import { render, staticRenderFns } from "./giftSee.vue?vue&type=template&id=fa519b38&"
import script from "./giftSee.vue?vue&type=script&lang=js&"
export * from "./giftSee.vue?vue&type=script&lang=js&"
import style0 from "./giftSee.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports